function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    Shape 2\n  ");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Sketch.\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1321.000000, -13.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1321.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#717375",
  d: "M6,0c3.3,0,6,2.7,6,6s-2.7,6-6,6S0,9.3,0,6S2.7,0,6,0L6,0z M6.3,0.6v2.5h1.9C8.1,2.7,8,2.4,7.8,2.1 C7.4,1.2,6.8,0.7,6.3,0.6L6.3,0.6z M5.7,0.6C5.2,0.7,4.6,1.2,4.2,2.1C4,2.4,3.9,2.7,3.8,3.1h1.9V0.6z M7.6,0.8 c0.3,0.3,0.5,0.6,0.7,1c0.2,0.4,0.4,0.8,0.5,1.2h1.8C9.9,2,8.9,1.2,7.6,0.8L7.6,0.8z M4.4,0.8C3.1,1.2,2.1,2,1.4,3.1h1.8 c0.1-0.5,0.3-0.9,0.5-1.2C3.9,1.4,4.1,1.1,4.4,0.8z M10.9,3.6H9C9.1,4.3,9.2,5,9.2,5.7h2.2C11.4,5,11.2,4.3,10.9,3.6z M8.4,3.6 H6.3v2.1h2.4C8.6,5,8.5,4.3,8.4,3.6z M5.7,3.6H3.6C3.5,4.3,3.4,5,3.4,5.7h2.4V3.6z M3,3.6H1.1C0.8,4.3,0.6,5,0.6,5.7h2.2 C2.8,5,2.9,4.3,3,3.6z M11.4,6.3H9.2C9.2,7,9.1,7.7,9,8.4h1.9C11.2,7.7,11.4,7,11.4,6.3z M8.6,6.3H6.3v2.1h2.1 C8.5,7.7,8.6,7,8.6,6.3z M5.7,6.3H3.4c0,0.7,0.1,1.5,0.3,2.1h2.1V6.3z M2.8,6.3H0.6c0,0.7,0.2,1.5,0.5,2.1H3 C2.9,7.7,2.8,7,2.8,6.3z M10.6,8.9H8.8c-0.1,0.5-0.3,0.9-0.5,1.2c-0.2,0.4-0.4,0.7-0.7,1C8.9,10.8,9.9,10,10.6,8.9L10.6,8.9z  M8.2,8.9H6.3v2.5c0.6-0.1,1.1-0.6,1.5-1.5C8,9.6,8.1,9.3,8.2,8.9L8.2,8.9z M5.7,8.9H3.8c0.1,0.4,0.2,0.7,0.4,1 c0.4,0.8,1,1.4,1.5,1.5V8.9z M3.2,8.9H1.4c0.7,1.1,1.7,1.9,3,2.3c-0.3-0.3-0.5-0.6-0.7-1C3.5,9.8,3.3,9.4,3.2,8.9L3.2,8.9z"
}))))));

function SvgLanguageSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLanguageSelection;